export default {
  'step-forward': '\\E600',
  'step-backward': '\\E601',
  forward: '\\E602',
  backward: '\\E603',
  'caret-right': '\\E604',
  'caret-left': '\\E605',
  'caret-down': '\\E606',
  'caret-up': '\\E607',
  'right-circle': '\\E608',
  'circle-right': '\\E608',
  'caret-circle-right': '\\E608',
  'left-circle': '\\E609',
  'circle-left': '\\E609',
  'caret-circle-left': '\\E609',
  'up-circle': '\\E60A',
  'circle-up': '\\E60A',
  'caret-circle-up': '\\E60A',
  'down-circle': '\\E60B',
  'circle-down': '\\E60B',
  'caret-circle-down': '\\E60B',
  'right-circle-o': '\\E60C',
  'circle-o-right': '\\E60C',
  'caret-circle-o-right': '\\E60C',
  'left-circle-o': '\\E60D',
  'circle-o-left': '\\E60D',
  'caret-circle-o-left': '\\E60D',
  'up-circle-o': '\\E60E',
  'circle-o-up': '\\E60E',
  'caret-circle-o-up': '\\E60E',
  'down-circle-o': '\\E60F',
  'circle-o-down': '\\E60F',
  'caret-circle-o-down': '\\E60F',
  'verticle-left': '\\E610',
  'verticle-right': '\\E611',
  rollback: '\\E612',
  retweet: '\\E613',
  shrink: '\\E614',
  'arrows-alt': '\\E615',
  'arrow-salt': '\\E615',
  reload: '\\E616',
  'double-right': '\\E617',
  'double-left': '\\E618',
  'arrow-down': '\\E619',
  'arrow-up': '\\E61A',
  'arrow-right': '\\E61B',
  'arrow-left': '\\E61C',
  down: '\\E61D',
  up: '\\E61E',
  right: '\\E61F',
  left: '\\E620',
  'minus-square-o': '\\E621',
  'minus-circle': '\\E622',
  'minus-circle-o': '\\E623',
  minus: '\\E624',
  'plus-circle-o': '\\E625',
  'plus-circle': '\\E626',
  plus: '\\E627',
  'info-circle': '\\E628',
  'info-circle-o': '\\E629',
  info: '\\E62A',
  exclamation: '\\E62B',
  'exclamation-circle': '\\E62C',
  'exclamation-circle-o': '\\E62D',
  'close-circle': '\\E62E',
  'cross-circle': '\\E62E',
  'close-circle-o': '\\E62F',
  'cross-circle-o': '\\E62F',
  'check-circle': '\\E630',
  'check-circle-o': '\\E631',
  check: '\\E632',
  close: '\\E633',
  cross: '\\E633',
  'customer-service': '\\E634',
  customerservice: '\\E634',
  'credit-card': '\\E635',
  'code-o': '\\E636',
  book: '\\E637',
  bars: '\\E639',
  question: '\\E63A',
  'question-circle': '\\E63B',
  'question-circle-o': '\\E63C',
  pause: '\\E63D',
  'pause-circle': '\\E63E',
  'pause-circle-o': '\\E63F',
  'clock-circle': '\\E640',
  'clock-circle-o': '\\E641',
  swap: '\\E642',
  'swap-left': '\\E643',
  'swap-right': '\\E644',
  'plus-square-o': '\\E645',
  frown: '\\E646',
  'frown-circle': '\\E646',
  ellipsis: '\\E647',
  copy: '\\E648',
  'menu-fold': '\\E9AC',
  mail: '\\E659',
  logout: '\\E65A',
  link: '\\E65B',
  'area-chart': '\\E65C',
  'line-chart': '\\E65D',
  home: '\\E65E',
  laptop: '\\E65F',
  star: '\\E660',
  'star-o': '\\E661',
  folder: '\\E662',
  filter: '\\E663',
  file: '\\E664',
  exception: '\\E665',
  meh: '\\E666',
  'meh-circle': '\\E666',
  'meh-o': '\\E667',
  'shopping-cart': '\\E668',
  save: '\\E669',
  user: '\\E66A',
  'video-camera': '\\E66B',
  'to-top': '\\E66C',
  team: '\\E66D',
  tablet: '\\E66E',
  solution: '\\E66F',
  search: '\\E670',
  'share-alt': '\\E671',
  setting: '\\E672',
  poweroff: '\\E6D5',
  picture: '\\E674',
  phone: '\\E675',
  'paper-clip': '\\E676',
  notification: '\\E677',
  mobile: '\\E678',
  'menu-unfold': '\\E9AD',
  inbox: '\\E67A',
  lock: '\\E67B',
  qrcode: '\\E67C',
  'play-circle': '\\E6D0',
  'play-circle-o': '\\E6D1',
  tag: '\\E6D2',
  'tag-o': '\\E6D3',
  tags: '\\E67D',
  'tags-o': '\\E67E',
  'cloud-o': '\\E67F',
  cloud: '\\E680',
  'cloud-upload': '\\E681',
  'cloud-download': '\\E682',
  'cloud-download-o': '\\E683',
  'cloud-upload-o': '\\E684',
  environment: '\\E685',
  'environment-o': '\\E686',
  eye: '\\E687',
  'eye-o': '\\E688',
  camera: '\\E689',
  'camera-o': '\\E68A',
  windows: '\\E68B',
  apple: '\\E68C',
  'apple-o': '\\E6D4',
  android: '\\E938',
  'android-o': '\\E68D',
  aliwangwang: '\\E68E',
  'aliwangwang-o': '\\E68F',
  export: '\\E691',
  edit: '\\E692',
  'circle-down-o': '\\E693',
  'circle-down-': '\\E694',
  'appstore-o': '\\E695',
  appstore: '\\E696',
  scan: '\\E697',
  'file-text': '\\E698',
  'folder-open': '\\E699',
  hdd: '\\E69A',
  ie: '\\E69B',
  'file-jpg': '\\E69C',
  like: '\\E64C',
  'like-o': '\\E69D',
  dislike: '\\E64B',
  'dislike-o': '\\E69E',
  delete: '\\E69F',
  enter: '\\E6A0',
  'pushpin-o': '\\E6A1',
  pushpin: '\\E6A2',
  heart: '\\E6A3',
  'heart-o': '\\E6A4',
  'pay-circle': '\\E6A5',
  'pay-circle-o': '\\E6A6',
  smile: '\\E6A7',
  'smile-circle': '\\E6A7',
  'smile-o': '\\E6A8',
  'frown-o': '\\E6A9',
  calculator: '\\E6AA',
  message: '\\E6AB',
  chrome: '\\E6AC',
  github: '\\E6AD',
  'file-unknown': '\\E6AF',
  'file-excel': '\\E6B0',
  'file-ppt': '\\E6B1',
  'file-word': '\\E6B2',
  'file-pdf': '\\E6B3',
  desktop: '\\E6B4',
  upload: '\\E6B6',
  download: '\\E6B7',
  'pie-chart': '\\E6B8',
  unlock: '\\E6BA',
  calendar: '\\E6BB',
  'windows-o': '\\E6BC',
  'dot-chart': '\\E6BD',
  'bar-chart': '\\E6BE',
  code: '\\E6BF',
  api: '\\E951',
  'plus-square': '\\E6C0',
  'minus-square': '\\E6C1',
  'close-square': '\\E6C2',
  'close-square-o': '\\E6C3',
  'check-square': '\\E6C4',
  'check-square-o': '\\E6C5',
  'fast-backward': '\\E6C6',
  'fast-forward': '\\E6C7',
  'up-square': '\\E6C8',
  'down-square': '\\E6C9',
  'left-square': '\\E6CA',
  'right-square': '\\E6CB',
  'right-square-o': '\\E6CC',
  'left-square-o': '\\E6CD',
  'down-square-o': '\\E6CE',
  'up-square-o': '\\E6CF',
  loading: '\\E64D',
  'loading-3-quarters': '\\E6AE',
  bulb: '\\E649',
  select: '\\E64A',
  addfile: '\\E910',
  'file-add': '\\E910',
  addfolder: '\\E914',
  'folder-add': '\\E914',
  switcher: '\\E913',
  rocket: '\\E90F',
  dingding: '\\E923',
  'dingding-o': '\\E925',
  bell: '\\E64E',
  disconnect: '\\E64F',
  database: '\\E650',
  compass: '\\E6DB',
  barcode: '\\E652',
  hourglass: '\\E653',
  key: '\\E654',
  flag: '\\E655',
  layout: '\\E656',
  login: '\\E657',
  printer: '\\E673',
  sound: '\\E6E9',
  usb: '\\E6D7',
  skin: '\\E6D8',
  tool: '\\E6D9',
  sync: '\\E6DA',
  wifi: '\\E6D6',
  car: '\\E6DC',
  copyright: '\\E6DE',
  schedule: '\\E6DF',
  'user-add': '\\E6ED',
  'user-delete': '\\E6E0',
  'usergroup-add': '\\E6DD',
  'usergroup-delete': '\\E6E1',
  man: '\\E6E2',
  woman: '\\E6EC',
  shop: '\\E6E3',
  gift: '\\E6E4',
  idcard: '\\E6E5',
  'medicine-box': '\\E6E6',
  'red-envelope': '\\E6E7',
  coffee: '\\E6E8',
  trademark: '\\E651',
  safety: '\\E6EA',
  wallet: '\\E6EB',
  bank: '\\E6EE',
  trophy: '\\E6EF',
  contacts: '\\E6F0',
  global: '\\E6F1',
  shake: '\\E94F',
  fork: '\\E6F2',
  dashboard: '\\E99A',
  profile: '\\E999',
  table: '\\E998',
  warning: '\\E997',
  form: '\\E996',
  'weibo-square': '\\E6F5',
  'weibo-circle': '\\E6F4',
  'taobao-circle': '\\E6F3',
  html5: '\\E9C7',
  weibo: '\\E9C6',
  twitter: '\\E9C5',
  wechat: '\\E9C4',
  youtube: '\\E9C3',
  'alipay-circle': '\\E9C2',
  taobao: '\\E9C1',
  skype: '\\E9C0',
  qq: '\\E9BF',
  'medium-workmark': '\\E9BE',
  gitlab: '\\E9BD',
  medium: '\\E9BC',
  linkedin: '\\E9BB',
  'google-plus': '\\E9BA',
  dropbox: '\\E9B9',
  facebook: '\\E9B8',
  codepen: '\\E9B7',
  amazon: '\\E9B6',
  google: '\\E9B5',
  'codepen-circle': '\\E9B4',
  alipay: '\\E9B3',
  'ant-design': '\\E9B2',
  aliyun: '\\E9F4',
  zhihu: '\\E703',
  'file-markdown': '\\E704',
  slack: '\\E705',
  'slack-square': '\\E706',
  behance: '\\E707',
  'behance-square': '\\E708',
  dribbble: '\\E709',
  'dribbble-square': '\\E70A',
  instagram: '\\E70B',
  yuque: '\\E70C'
};



// WEBPACK FOOTER //
// ./src/components/Icon/private/iconGlyphsMap.ts